import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Feature } from "ol";
import { useDrawingContext } from "../../Contexts/DrawingContext";
import { DrawType } from "../../Map/enums";

export interface ISketchProps {
    feature: Feature;
}
export const SketchProps = ({ feature }: ISketchProps): JSX.Element => {
    const [note, setNote] = useState<string>("");
    const { onNoteChange, onDeleteFeature, selectedFeature, setSelectedFeature } = useDrawingContext();

    useEffect(() => {
        setNote(feature.get("DESCRIPTION"));
    }, []);

    const onChange = (e) => {
        setNote(e.target.value);
        feature.set("DESCRIPTION", e.target.value);
        onNoteChange();
    };

    const featureType = feature.get("DRAWTYPE");
    const hasSymbolLabel = featureType !== DrawType.Polygon && featureType !== DrawType.Polyline;

    return (
        <div
            className={classNames("draw-note", {
                selected: selectedFeature && feature.get("TEMPID") === selectedFeature.get("TEMPID")
            })}
        >
            {hasSymbolLabel && <SymbolLabel type={featureType}></SymbolLabel>}
            <input
                type="text"
                placeholder="Piezīmes"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e)}
                onFocus={() => setSelectedFeature(feature)}
                value={note}
            />
            <div className="draw-delete" onClick={() => onDeleteFeature(feature)}>
                <span className="icon-zemesnoma-bin"></span>
            </div>
        </div>
    );
};

const SymbolLabel = ({ type }: { type: DrawType }) => (
    <div className="symbol-label">
        <span
            className={
                type === DrawType.PointCarPark
                    ? "icon-zemesnoma-car-parking"
                    : type === DrawType.PointInfra
                    ? "icon-zemesnoma-infrastructure"
                    : type === DrawType.PointTent
                    ? "icon-zemesnoma-tent"
                    : type === DrawType.PointGathering
                    ? "icon-zemesnoma-gathering"
                    : type === DrawType.PointOther
                    ? "icon-zemesnoma-other"
                    : null
            }
        ></span>
    </div>
);
